export default "__VITE_ASSET__DERe8BVZ__"